import { render, staticRenderFns } from "./DisplayResults.vue?vue&type=template&id=ce06e782&scoped=true&"
import script from "./DisplayResults.vue?vue&type=script&lang=js&"
export * from "./DisplayResults.vue?vue&type=script&lang=js&"
import style0 from "./DisplayResults.vue?vue&type=style&index=0&id=ce06e782&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce06e782",
  null
  
)

export default component.exports